import { render, staticRenderFns } from "./OnSaleToPrivates.vue?vue&type=template&id=2171fc7e&"
import script from "./OnSaleToPrivates.vue?vue&type=script&lang=js&"
export * from "./OnSaleToPrivates.vue?vue&type=script&lang=js&"
import style0 from "./OnSaleToPrivates.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OnSaleToPrivates.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports